import { render, staticRenderFns } from "./Cash.vue?vue&type=template&id=6a568c2b&scoped=true"
import script from "./Cash.vue?vue&type=script&lang=js"
export * from "./Cash.vue?vue&type=script&lang=js"
import style0 from "./Cash.vue?vue&type=style&index=0&id=6a568c2b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a568c2b",
  null
  
)

export default component.exports